import { v4 as uuid } from 'uuid'
import { userToCreateParams, userToUpdateParams } from 'transforms/users'
import client, { deserializer } from 'services/client'
import { toCamel, toSnake } from 'change-object-case'

async function saveUser(user) {
  if (user.id) {
    return await updateUser(user.id, user)
  } else {
    return await createUser(user)
  }
}

async function updateUser(id, user) {
  const requestBody = userToUpdateParams(user)
  const responseBody = await client().put(`/v2/users/${id}`, requestBody)

  return deserializer.deserialize(responseBody)
}

async function createUser(user) {
  const requestBody = userToCreateParams(user)
  const responseBody = await client().post('/v2/users', { id: uuid(), ...requestBody })

  return deserializer.deserialize(responseBody)
}

async function getUsers(params) {
  const response = await client().get('/v2/users', { params: toSnake(params) })

  return {
    data: deserializer.deserialize(response),
    meta: toCamel(response.meta),
  }
}

async function getUser(id) {
  const response = await client().get(`v2/users/${id}`)

  return deserializer.deserialize(response)
}

async function inviteUser(id) {
  const response = await client().post(`v2/users/${id}/invite`)

  return response
}

async function getUserIdentities(userId) {
  const response = await client().get(`/v2/users/${userId}/identities`)
  return deserializer.deserialize(response)
}

async function createAuth0Identity(userId) {
  const response = await client().post(`/v2/users/${userId}/identities/auth0`)
  return response
}

async function syncWithFdsAdmin(serialNumbers) {
  const response = await client().post('/v2/users/sync_with_fdsadmin', {
    username_serials: serialNumbers,
  })
  // no need to deserialize response since it just returns plain json
  return response
}

async function importFdsadminUser(serialNumber) {
  const response = await client().post('/v2/users/import_fdsadmin_user', {
    username_serial: serialNumber,
  })
  return deserializer.deserialize(response)
}

export {
  saveUser,
  updateUser,
  createUser,
  getUsers,
  getUser,
  inviteUser,
  getUserIdentities,
  createAuth0Identity,
  syncWithFdsAdmin,
  importFdsadminUser,
}
